import * as React from 'react';
import AppTabs from '../../../components/AppTabs';
import { useState } from 'react';
import { useTranslations } from '../../../store/translations/hooks';
import { TK } from '../../../store/translations/translationKeys';
import { SettingsItemContentProps } from '../SettingsItem';
import { ClientsLoginSettingsData, MintuSettingsData, SelfSchedulingSettingsData } from '../../../models';
import { Alert } from 'reactstrap';
import { CheckInputField } from '../../../components/Forms/fields/CheckInputField';
import { Tabs, Tab } from '@material-ui/core';
import { ClientsPortalTab } from './ClientsPortalTab';
import { ConfigurationTab } from './ConfigurationTab';
import { NotificationsTab } from './NotificationsTab';
import { MintuTab } from './MintuTab';

type TabId = 'clientsPortal' | 'onlineScheduling' | 'notifications' | 'mintu';

export interface ClientsLoginSettingsProps extends SettingsItemContentProps {
    values: ClientsLoginSettingsData,
    onChange: (settings: ClientsLoginSettingsData) => void
}

const ClientsLoginSettings: React.FC<ClientsLoginSettingsProps> = (props) => {
    const { id, values, onChange } = props;

    const t = useTranslations();
    const [tab, setTab] = useState<TabId>('clientsPortal');

    const onSettingChanged = (settings: Partial<ClientsLoginSettingsData>) => onChange({
        ...(values ?? {}),
        ...settings,
    });

    const onSelfSchedulingChanged = (selfScheduling: Partial<SelfSchedulingSettingsData>) => onSettingChanged({
        selfScheduling: {
            ...(values?.selfScheduling ?? {} as SelfSchedulingSettingsData),
            ...selfScheduling,
        }
    });

    const onMintuChanged = (mintu: Partial<MintuSettingsData>) => onSettingChanged({
        mintu: {
            ...(values?.mintu ?? {} as MintuSettingsData),
            ...mintu,
        }
    });

    return (
        <div style={{display: 'flex', flexDirection: 'column', gap: 'var(--spacer-S)'}}>
            <Alert color="secondary" isOpen>
                {t(TK.clientsAccessSettingsDescription)}
            </Alert>

            <CheckInputField
                id={`${id}-enabled`}
                label={t(TK.allowClientsLogin)}
                value={values?.enabled}
                onChange={enabled => onSettingChanged({enabled})}/>

            {values?.enabled && <>
                <AppTabs value={tab} onChange={(_, v) => setTab(v)} indicatorColor="primary" textColor="primary" style={{marginBottom: 'var(--spacer-S)', borderBottom: 'var(--border-thin) solid var(--appLigthGrey)'}}>
                    <Tab label={t(TK.clientsPortal)} value="clientsPortal" />
                    <Tab label={t(TK.onlineScheduling)} value="onlineScheduling" />
                    <Tab label={t(TK.notifications)} value="notifications" />
                    <Tab label={t(TK.mintuAiWhatsApp)} value="mintu" />
                </AppTabs>

                <div>
                    {tab === 'clientsPortal' && <ClientsPortalTab id={id} values={values} onSelfSchedulingChanged={onSelfSchedulingChanged}/>}
                    {tab === 'onlineScheduling' && <ConfigurationTab id={id} values={values} onSelfSchedulingChanged={onSelfSchedulingChanged}/>}
                    {tab === 'notifications' && <NotificationsTab id={id} values={values} onSelfSchedulingChanged={onSelfSchedulingChanged}/>}
                    {tab === 'mintu' && <MintuTab id={id} values={values} onMintuChanged={onMintuChanged}/>}
                </div>
            </>}
        </div>
    );
};

export default ClientsLoginSettings;
